import React from 'react';

const SvgUz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="UZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="UZ_svg__b" fill="#fff">
        <use xlinkHref="#UZ_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#04AAC8" mask="url(#UZ_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#23C840" mask="url(#UZ_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M5.778 1.67a1.667 1.667 0 1 0 0 3.326 2 2 0 1 1 0-3.326zm1.555 3.663a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM10 2.667a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm2.667 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm0 2.666a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm-2.667 0A.667.667 0 1 1 10 4a.667.667 0 0 1 0 1.333z"
        fill="#FFF"
        mask="url(#UZ_svg__b)"
      />
    </g>
  </svg>
);

export default SvgUz;
